import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-link.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-link.component.css?ngResource";
import { Component } from '@angular/core';
export let CalciteLinkComponent = class CalciteLinkComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
CalciteLinkComponent = __decorate([
    Component({
        selector: 'lib-calcite-link',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteLinkComponent);
